import { render } from "./HelpManagePage.vue?vue&type=template&id=d5169b12&scoped=true"
import script from "./HelpManagePage.vue?vue&type=script&lang=js"
export * from "./HelpManagePage.vue?vue&type=script&lang=js"

import "./HelpManagePage.vue?vue&type=style&index=0&id=d5169b12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5169b12"]])

export default __exports__